/* Siestín — scripts propios (sin librerías) */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición al hacer scroll ---------- */
  var observer = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.fc-reveal:not(.fc-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('fc-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('fc-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Comparador antes / después ---------- */
  function initComparador(root) {
    (root || document).querySelectorAll('[data-fc-comp]').forEach(function (marco) {
      if (marco.dataset.fcListo) return;
      marco.dataset.fcListo = '1';
      var range = marco.querySelector('.fc-comp__range');
      if (!range) return;
      var pintar = function () { marco.style.setProperty('--fc-pos', range.value + '%'); };
      range.addEventListener('input', pintar);
      pintar();
      // Pequeña pista de movimiento la primera vez que se ve
      if (!reduce && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          var inicio = Number(range.value), t0 = null;
          var paso = function (t) {
            if (!t0) t0 = t;
            var p = Math.min((t - t0) / 1400, 1);
            range.value = inicio + Math.sin(p * Math.PI * 2) * 14;
            pintar();
            if (p < 1) requestAnimationFrame(paso); else { range.value = inicio; pintar(); }
          };
          requestAnimationFrame(paso);
        }, { threshold: 0.5 });
        io.observe(marco);
      }
    });
  }

  /* ---------- Página de producto ---------- */
  function formatear(cents, formato) {
    var v = (cents / 100).toFixed(2);
    var conComa = v.replace('.', ',');
    var f = formato || '{{amount_with_comma_separator}} €';
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
            .replace(/\{\{\s*amount\s*\}\}/, v)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-fc-producto]').forEach(function (prod) {
      if (prod.dataset.fcListo) return;
      prod.dataset.fcListo = '1';

      // Galería
      var principal = prod.querySelector('.fc-prod__principal img');
      prod.querySelectorAll('.fc-prod__mini').forEach(function (mini) {
        mini.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = mini.dataset.src;
            principal.srcset = mini.dataset.srcset || '';
            principal.alt = mini.dataset.alt || '';
            principal.style.opacity = '1';
          }, 150);
          prod.querySelectorAll('.fc-prod__mini').forEach(function (m) { m.classList.remove('is-activa'); });
          mini.classList.add('is-activa');
        });
      });

      // Cantidad
      var qty = prod.querySelector('.fc-qty input');
      prod.querySelectorAll('.fc-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.delta));
          qty.value = n;
        });
      });

      // Variantes
      var form = prod.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var boton = prod.querySelector('[data-fc-boton]');
      var botonTxt = boton ? boton.querySelector('span') : null;
      var precioEl = prod.querySelector('[data-fc-precio]');
      var antesEl = prod.querySelector('[data-fc-antes]');
      var datos = prod.querySelector('[data-fc-variantes]');
      var formato = prod.dataset.formato;
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var selects = prod.querySelectorAll('[data-fc-opcion]');

      function actualizar() {
        var elegidas = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        if (!v) {
          if (boton) boton.disabled = true;
          if (botonTxt) botonTxt.textContent = prod.dataset.txtNoDisponible;
          return;
        }
        if (idInput) idInput.value = v.id;
        if (precioEl) precioEl.textContent = formatear(v.price, formato);
        pintarCant(v.price);
        if (antesEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            antesEl.textContent = formatear(v.compare_at_price, formato);
            antesEl.hidden = false;
          } else { antesEl.hidden = true; }
        }
        if (boton) boton.disabled = !v.available;
        if (botonTxt) botonTxt.textContent = v.available ? prod.dataset.txtBoton : prod.dataset.txtAgotado;
        if (v.featured_image && principal) {
          principal.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
          principal.srcset = '';
        }
      }
      // Selector 1 / 2 unidades con descuento
      var cantCaja = prod.querySelector('[data-fc-cant]');
      var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
      var cantRadios = prod.querySelectorAll('[data-fc-cant-opcion]');
      function pintarCant(precio) {
        if (!cantCaja) return;
        var d = Number(cantCaja.dataset.fcCant) || 0;
        var dos = precio * 2;
        var p2 = (precio - Math.floor(precio * d / 100)) * 2;
        var set = function (sel, val) { var el = cantCaja.querySelector(sel); if (el) el.textContent = formatear(val, formato); };
        set('[data-fc-cant-1]', precio);
        set('[data-fc-cant-2]', p2);
        set('[data-fc-cant-unidad]', Math.floor(p2 / 2));
        set('[data-fc-cant-antes]', dos);
      }
      function marcarCant(n) {
        cantRadios.forEach(function (o) {
          o.checked = Number(o.value) === n;
          o.closest('.fc-pack').classList.toggle('is-activo', o.checked);
        });
      }
      cantRadios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (qtyInput) qtyInput.value = r.value;
          marcarCant(Number(r.value));
        });
      });
      if (qtyInput && cantRadios.length) {
        var syncQty = function () { marcarCant(Number(qtyInput.value) >= 2 ? 2 : 1); };
        qtyInput.addEventListener('change', syncQty);
        prod.querySelectorAll('.fc-qty button').forEach(function (b) { b.addEventListener('click', function () { setTimeout(syncQty, 0); }); });
      }

      selects.forEach(function (s) { s.addEventListener('change', actualizar); });

      // Botones de opción (color, tamaño): sincronizan los selectores ocultos
      var pills = prod.querySelectorAll('[data-fc-pill]');
      pills.forEach(function (r) {
        r.addEventListener('change', function () {
          var i = Number(r.dataset.fcPill);
          if (selects[i]) { selects[i].value = r.value; actualizar(); }
          var grupo = r.closest('.fc-pills');
          grupo.querySelectorAll('.fc-pill').forEach(function (l) { l.classList.toggle('is-activo', l.querySelector('input').checked); });
          var valor = grupo.parentNode.querySelector('[data-fc-opcion-valor]');
          if (valor) valor.textContent = r.value;
        });
      });

      // Tarjetas de pack: sincronizan el selector oculto
      var packs = prod.querySelectorAll('[data-fc-pack]');
      packs.forEach(function (r) {
        r.addEventListener('change', function () {
          if (selects[0]) { selects[0].value = r.value; actualizar(); }
          packs.forEach(function (o) { o.closest('.fc-pack').classList.toggle('is-activo', o.checked); });
        });
      });

      // Añadir al carrito (abre el carrito lateral de Dawn si existe)
      if (form) {
        form.addEventListener('submit', function (ev) {
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (!window.fetch || !cart || typeof cart.renderContents !== 'function') return; // envío normal
          ev.preventDefault();
          var err = prod.querySelector('.fc-prod__error');
          if (err) err.style.display = 'none';
          if (boton) { boton.disabled = true; boton.classList.add('is-cargando'); }
          var fd = new FormData(form);
          var secciones = cart.getSectionsToRender ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
          fd.append('sections', secciones);
          fd.append('sections_url', window.location.pathname);
          if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
          fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res.status) {
              if (err) { err.textContent = res.description || res.message; err.style.display = 'block'; }
              return;
            }
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(res);
          }).catch(function () { form.submit(); })
            .finally(function () { if (boton) { boton.disabled = false; boton.classList.remove('is-cargando'); } });
        });
      }

      // Barra fija en móvil
      var barra = prod.querySelector('.fc-barra');
      if (barra && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(boton);
        var bb = barra.querySelector('button');
        if (bb) bb.addEventListener('click', function () {
          if (boton.disabled) return;
          if (form.requestSubmit) form.requestSubmit(boton); else boton.click();
        });
      }
    });
  }

  // Selector de packs fuera de la página de producto (portada, llamada final)
  function initCompra(root) {
    (root || document).querySelectorAll('[data-fc-compra]').forEach(function (caja) {
      if (caja.dataset.fcListo) return;
      caja.dataset.fcListo = '1';
      var form = caja.querySelector('form');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var boton = caja.querySelector('[data-fc-compra-boton]');
      var radios = caja.querySelectorAll('[data-fc-pack-id]');
      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (idInput) idInput.value = r.value;
          radios.forEach(function (o) { o.closest('.fc-pack').classList.toggle('is-activo', o.checked); });
        });
      });
      if (!form) return;
      form.addEventListener('submit', function (ev) {
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (!window.fetch || !cart || typeof cart.renderContents !== 'function') return;
        ev.preventDefault();
        var err = caja.querySelector('.fc-prod__error');
        if (err) err.style.display = 'none';
        if (boton) { boton.disabled = true; boton.classList.add('is-cargando'); }
        var fd = new FormData(form);
        var secciones = cart.getSectionsToRender ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
        fd.append('sections', secciones);
        fd.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: fd
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) {
            if (err) { err.textContent = res.description || res.message; err.style.display = 'block'; }
            return;
          }
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(res);
        }).catch(function () { form.submit(); })
          .finally(function () { if (boton) { boton.disabled = false; boton.classList.remove('is-cargando'); } });
      });
    });
  }

  function initTodo(root) {
    initCompra(root);
    initReveal(root);
    initComparador(root);
    initProducto(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
